export default __webpack_public_path__ + "static/media/Hair_14.cd6986d3.svg";